import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Route, useLocation, Routes, Navigate, useNavigate } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";
import { ManageModal, ManageModalProvider, } from "ui";
import { SlideIn, SlideInContextProvider } from "ft-shared-graphql"
//ROUTES
import LoginPage from "./UserPages/Login";
import DashboardRoutes from "./DashboardPages/DashboardRoutes";
import { CompanyRoutes } from "./CompanyPages/CompanyRoutes";
import { LocationRoutes } from "./LocationPages/LocationRoutes";
import { StaffRoutes } from "./StaffPages/StaffRoutes";
import { AnswerRoutes } from "./AnswerPages/AnswerRoutes";

//CONTEXT PROVIDERS
import { CompanyProvider } from "../context/CompanyContext";
import { LocationProvider } from "../context/LocationContext";
import { SessionProvider } from "../context/SessionContext";
import { AnswerProvider } from "../context/AnswerContext";
import { SelectedPersonProvider } from "../context/StaffContext/StaffProvider";
import { TestSlideInContextProvider } from "../context/TestSlideInContext";
//STORES
import usePersonStore from "./store/personStore";
import usePersonAuthStore from './store/personAuthStore'
import TestSlideIn from "./components/TestSlideIn/TestSlideIn";
import { GlobalRoutes } from "./GlobalPages/GlobalRoutes";

const RenderRoutes = () => {
    const accessToken = usePersonAuthStore(state => state.access_token)
    const roles = usePersonAuthStore(state => state.roles);
    const hasRun = useRef(false)
    const [notDeveloper, setNotDeveloper] = useState(false)
    const destroyPersonStore = usePersonStore((state) => state.destroy);
    const destroyPersonAuthToken = usePersonAuthStore((state) => state.destroy);
    const setAuthValuesFromAccessToken = usePersonAuthStore(state => state.setAuthValuesFromAccessToken);
    useEffect(() => {
        if (!accessToken || roles.length > 0) {
            return
        }
        setAuthValuesFromAccessToken(accessToken)
    }, [accessToken]);
    useEffect(() => {
        if (hasRun.current || roles.length < 1) return;
        hasRun.current = true;
        if (!roles.includes("DEVELOPER")) {
            setNotDeveloper(true)
        }
    }, [roles])
    if (notDeveloper) {
        destroyPersonAuthToken();
        destroyPersonStore();
        return (
            <Box display="flex" alignItems="center" justifyContent="center" textAlign="center" sx={{ height: '100vh' }}>
                <Box sx={{ width: '500px', }}>
                    <Paper sx={{ padding: 4 }}>
                        <Typography variant="h5" sx={{ marginBottom: 2 }}>Not allowed</Typography>
                        <Typography>This is the futuresthrive Developer Portal. If you are looking for the client portal please visit futuresthrive.health.</Typography>
                    </Paper>
                </Box>
            </Box>
        )
    }
    return <Box component="div" sx={{ backgroundColor: "#F3F6F9", minHeight: "100vh" }}>
        <Router>
            <CompanyProvider>
                <LocationProvider>
                    <AnswerProvider>
                        <SessionProvider>
                            <SelectedPersonProvider>
                                <SlideInContextProvider>
                                    <TestSlideInContextProvider>
                                        <ManageModalProvider>
                                            <ManageModal />
                                            <SlideIn />
                                            <TestSlideIn />
                                            <Routes>
                                                <Route path="login" element={<LoginPage />} />
                                                <Route path="answer/*" element={<AnswerRoutes />} />
                                                <Route path="dashboard/*" element={<DashboardRoutes />} />
                                                <Route path="company/*" element={<CompanyRoutes />} />
                                                <Route path="location/*" element={<LocationRoutes />} />
                                                <Route path="staff/*" element={<StaffRoutes />} />
                                                <Route path="global-statistics/*" element={<GlobalRoutes />} />
                                                <Route path="*" element={<Navigate to="/login" replace />} />
                                            </Routes>
                                        </ManageModalProvider>
                                    </TestSlideInContextProvider>
                                </SlideInContextProvider>
                            </SelectedPersonProvider>

                        </SessionProvider>
                    </AnswerProvider>
                </LocationProvider>
            </CompanyProvider>
        </Router>
    </Box>
}

export default RenderRoutes